import { Rating } from "@mui/material";
import React from "react";

export default function Scores() {
  return (
    <>
      <div className="w-full h-full flex items-center justify-center ">
        <div className="rating rating-lg m-10">
          <input
            type="radio"
            defaultChecked={true}
            name="rating-8"
            className="mask mask-star-2 bg-orange-400"
            disabled={true}
          />
          <input
            type="radio"
            name="rating-8"
            defaultChecked={true}
            className="mask mask-star-2 bg-orange-400"
            disabled={true}
          />
          <input
            type="radio"
            name="rating-8"
            defaultChecked={true}
            className="mask mask-star-2 bg-orange-400"
            disabled={true}
          />
          <input
            type="radio"
            name="rating-8"
            defaultChecked={true}
            className="mask mask-star-2 bg-orange-400"
            disabled={true}
          />
          <input
            type="radio"
            name="rating-8"
            defaultChecked={true}
            className="mask mask-star-2 bg-orange-400"
            disabled={true}
          />
        </div>
      </div>
    </>
  );
}
